import { UploadFileProps } from '@anm/components/InputFile';
import { DEFAULT_VIDEO_NAME } from '@anm/constants/my-videos';
import cutFileExtension from '@anm/helpers/cutFileExtension';
import isIOS from '@anm/helpers/is/isIOS';
import { useDispatch, useSelector } from 'react-redux';
import { hostedVideoSelectors } from '../../../../../store/modules/hostedVideo';
import vtConfig from '../../../../../config';
import { uploadsActions } from '@anm/store/modules/uploads';
import { userSelectors } from '../../../../../store/modules/user';
import useProgressListener from '@anm/store/modules/uploads/hooks/useProgressListener';

const {
  uploadVideoDefaults: { metaInfo }
} = vtConfig();

const useUpload = () => {
  const dispatch = useDispatch();
  const user = useSelector(userSelectors.selectUser);
  const hostId = useSelector(hostedVideoSelectors.selectHostId);
  const hostingStats = useSelector(userSelectors.selectUserHostingStats)?.data || null;

  const listener = useProgressListener();

  const handleUpload = async (props: UploadFileProps[]) => {
    if (!hostId) return;

    const { file } = props[0];
    const name = isIOS() ? DEFAULT_VIDEO_NAME : cutFileExtension(file.name);
    const description = `${name} - ${metaInfo.description}`;

    dispatch(
      uploadsActions.createUpload({
        user: user.profile,
        hostingStats,
        uploadType: 'replace',
        isUploadFile: true,
        progressListener: listener,
        uploads: [
          {
            file,
            meta: { name, description }
          }
        ]
      })
    );
  };

  return handleUpload;
};

export default useUpload;
